<div class="row  align-items-center align-items-end">
  <div class="col-auto ">
    <p-datepicker
      #dp
      [(ngModel)]="this.selectedDateRange"
      selectionMode="range"
      [readonlyInput]="true"
      [showIcon]="false"
      [showOnFocus]="false"
      [autoZIndex]="true"
      [baseZIndex]="2000"
      [appendTo]="'body'"
      class="memory-filter-datepicker"
      panelStyleClass="memory-filter-datepicker-panel"
      (ngModelChange)="this.onMultiCopyDateSelection($event)"
      >
      <ng-template
        pTemplate="date"
        let-date
        >
        <span [class.dayHasData]="this.hasDataForDate(date)">{{date.day}}</span>
      </ng-template>
    </p-datepicker>

    <button
      pButton
      type="button"
      class="p-button-sm"
      (click)="dp.toggle()"
      >
      <i class="ri ri-calendar-2-line cursor-pointer"></i>
      @if (this.startEqualsEnd() && this.multiCopyFromDate && this.multiCopyToDate) {
        {{this.multiCopyFromDate.toDate() | date: 'dd/MM/yyyy'}}
      }

      @if (!this.startEqualsEnd()) {
        @if (this.multiCopyFromDate) {
          {{this.multiCopyFromDate.toDate() | date: 'dd/MM/yyyy'}}
        }
        bis
        @if (this.multiCopyToDate) {
          {{this.multiCopyToDate.toDate() | date: 'dd/MM/yyyy' }}
        }
        @if (!this.multiCopyToDate) {
          Heute
        }
      }
    </button>
  </div>
</div>